import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { getTemplateMails } from "../../../../api";
import type {
  TemplateMailItem,
  TemplateSelectValue,
} from "../../../../types/mail";

type TemplateSelectProps = {
  changedValue: (value: TemplateSelectValue) => void;
  value?: number | null;
};

const TemplateSelect = ({ changedValue, value }: TemplateSelectProps) => {
  const [mailTemplates, setMailTemplates] = useState<TemplateMailItem[]>([]);
  const [selectedTemplate, setSelectedTemplate] =
    useState<TemplateMailItem | null>(null);

  const getTemplates = async () => {
    try {
      const response = await getTemplateMails({
        title: null,
        content: null,
        order: null,
        sort: null,
        page: 1,
        limit: null,
      });
      if (response.status !== "ok") {
        return;
      }
      const data = response.mail_templates;
      if (data) {
        setMailTemplates(data);

        const initialTemplate = data.find((template) => template.id === value);
        setSelectedTemplate(initialTemplate ?? null);
      } else {
        console.error("ヒットするテンプレートなし");
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    getTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (value && mailTemplates.length > 0) {
      const initialTemplate = mailTemplates.find(
        (template) => template.id === value
      );
      setSelectedTemplate(initialTemplate ?? null);
    }
  }, [value, mailTemplates]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={mailTemplates}
      value={selectedTemplate}
      getOptionLabel={(template) => template.title}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField {...params} name="templateSelect" label="テンプレート選択" />
      )}
      onChange={(_event, newValues) => {
        setSelectedTemplate(newValues);
        changedValue({
          id: newValues?.id,
          name: newValues?.name as string | undefined,
          content: newValues?.content,
          title: newValues?.title,
        });
      }}
    />
  );
};

export default TemplateSelect;
